<template>
  <slot v-if="isVisible === true" />
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { getActiveThemeKey, normalizeThemeKey } from '@/Themes/themeRuntime.js';

const props = defineProps({
  theme: {
    type: String,
    required: true
  },
  invert: {
    type: Boolean,
    default: false
  }
});

function resolveAppliedThemeKey() {
  if (typeof document !== 'undefined') {
    const linkEl = document.getElementById('platform-theme-styles');
    const href = linkEl !== null && linkEl !== undefined && typeof linkEl.href == 'string' ? linkEl.href : '';
    const normalizedHref = typeof href == 'string' ? href.trim() : '';
    if (normalizedHref.length > 0) {
      return normalizeThemeKey(normalizedHref);
    }
  }
  return getActiveThemeKey();
}

const activeThemeKey = computed(() => resolveAppliedThemeKey());
const instance = getCurrentInstance();

const normalizedTheme = computed(() => {
  const raw = typeof props.theme == 'string' ? props.theme.trim() : '';
  if (raw.length < 1) {
    return '';
  }
  return normalizeThemeKey(raw);
});

const isDedicatedModernView = computed(() => {
  const parentFile = instance !== null && instance.parent !== null && instance.parent.type !== null && typeof instance.parent.type.__file == 'string' ? instance.parent.type.__file : '';
  if (parentFile == '') {
    return false;
  }
  const normalizedPath = parentFile.replace(/\\/g, '/');
  return normalizedPath.includes('/src/Themes/modern/views/') !== false || normalizedPath.endsWith('/src/views/DashboardV3.vue') !== false;
});

const isVisible = computed(() => {
  let match = activeThemeKey.value == normalizedTheme.value;
  if (normalizedTheme.value == 'modern' && isDedicatedModernView.value == false) {
    match = false;
  }
  if (props.invert == true) {
    return match == false;
  }
  return match == true;
});
</script>
